import type { DescriptionsProps } from "antd";
import { Card, Descriptions } from "antd";

export const CustomerAssociation = ({ isLoading, productData, title }) => {
  const customerAssociation = productData?.getProductCustomerAssociation();
  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Commission Rate type",
      children: customerAssociation?.getCommissionRateType(),
    },
    {
      key: "2",
      label: "Commission Rate",
      children: customerAssociation?.getCommissionRate(),
    },
    {
      key: "3",
      label: "Fx Rate",
      children: customerAssociation?.getFxRate() || "none",
    },
    {
      key: "4",
      label: "Tax",
      children: customerAssociation?.getIncludeTax() || "none",
    },
    {
      key: "5",
      label: "Tax Total",
      children: customerAssociation?.getTaxTotal() || "none",
    },
    {
      key: "6",
      label: "Sub Total",
      children: customerAssociation?.getSubTotal() || "none",
    },
    {
      key: "7",
      label: "Total",
      children: customerAssociation?.getTotal() || "none",
    },
    {
      key: "8",
      label: "Original Sub Total",
      children: customerAssociation?.getTotal() || "none",
    },
    {
      key: "9",
      label: "Original Total",
      children: customerAssociation?.getOriginalTotal() || "none",
    },
    {
      key: "10",
      label: "Discount Total",
      children: customerAssociation?.getDiscountTotal() || "none",
    },
  ];
  return (
    <Card title={title} bordered={false} loading={isLoading}>
      {customerAssociation ? (
        <Descriptions bordered size="small" layout="vertical" items={items} />
      ) : (
        "Customer association not available yet."
      )}
    </Card>
  );
};
